import Excel from "./Excel";

const ExcelContainer = props => {
  return <Excel {...props} />;
};

export default ExcelContainer;
